export const DEFAULT_ALL_TAB_TEXT = "ALL";
export const NEWSROOM_RESTORATION_ID = "NEWSROOM_RESTORATION_ID";
